import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
const firebaseConfig = {
  apiKey: "AIzaSyDrnhmWA5fRo613i_LBh1xaQym7VodTouA",
  authDomain: "salezjanie.firebaseapp.com",
  projectId: "salezjanie",
  storageBucket: "salezjanie.firebasestorage.app",
  messagingSenderId: "374735556113",
  appId: "1:374735556113:web:875aff7967338e34202bb0"
};

const app = initializeApp(firebaseConfig);

// Initialize Firebase App Check with reCAPTCHA v3
if (typeof window !== "undefined") {
    initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider("6Ler3JAsAAAAAD4f0ojAny2Py55lGB2vcRpNdlPT"),
        // Automatically refresh tokens as needed
        isTokenAutoRefreshEnabled: true
    });
}

export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const storage = getStorage(app);
